import React from 'react';
import html2canvas from 'html2canvas';
import { QRCodeSVG } from 'qrcode.react';

const WOMAN_IMG = 'https://images.unsplash.com/photo-1651761126587-8530108be76b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHx3b21hbiUyMGFybXMlMjByYWlzZWQlMjBmcmVlZG9tJTIwbGlnaHQlMjBzcGlyaXR1YWwlMjBwcmFpc2V8ZW58MHx8fHwxNzc0NTUxOTA4fDA&ixlib=rb-4.1.0&q=85';
const BIBLE_IMG = 'https://images.unsplash.com/photo-1478033332825-3418438ab019?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxNzV8MHwxfHNlYXJjaHwyfHxvcGVuJTIwaG9seSUyMGJpYmxlJTIwZ29sZGVuJTIwbGlnaHQlMjBwYWdlc3xlbnwwfHx8fDE3NzQ1NTE5MTl8MA&ixlib=rb-4.1.0&q=85';

export const SocialFlyer = () => {
  const handleDownload = async () => {
    const el = document.getElementById('flyer-canvas');
    if (!el) return;
    try {
      const canvas = await html2canvas(el, { useCORS: true, scale: 3, backgroundColor: null });
      const link = document.createElement('a');
      link.download = 'Purpose-Reclaimed-Flyer.png';
      link.href = canvas.toDataURL('image/png');
      link.click();
    } catch (e) {
      console.error('Download error:', e);
    }
  };

  return (
    <div data-testid="social-flyer" style={{ minHeight: '100vh', background: '#2D2030', display: 'flex', flexDirection: 'column', alignItems: 'center', padding: '12px' }}>

      {/* A4 Flyer — fixed 595×842 ratio scaled to fit screen */}
      <div 
        id="flyer-canvas"
        style={{
          width: '100%',
          maxWidth: '420px',
          aspectRatio: '595 / 842',
          background: 'linear-gradient(155deg, #5C0C33 0%, #3D0822 45%, #4A0E2A 100%)',
          position: 'relative',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          padding: '5% 5.5%',
        }}
      >
        {/* Border */}
        <div style={{ position: 'absolute', inset: '6px', border: '1px solid rgba(212,175,55,0.3)', pointerEvents: 'none', zIndex: 20 }} />

        {/* TOP SECTION */}
        <div>
          {/* Header */}
          <div style={{ textAlign: 'center', marginBottom: '3%' }}>
            <p style={{ color: 'white', fontSize: 'clamp(13px, 3.8vw, 20px)', fontStyle: 'italic', fontFamily: "'Cormorant Garamond', serif", margin: 0, letterSpacing: '0.5px' }}>
              Purpose Reclaimed Coaching
            </p>
            <div style={{ margin: '5px auto', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '5px' }}>
              <div style={{ width: '28px', height: '1px', background: 'linear-gradient(90deg, transparent, #D4AF37)' }} />
              <div style={{ width: '5px', height: '5px', background: '#D4AF37', transform: 'rotate(45deg)' }} />
              <div style={{ width: '28px', height: '1px', background: 'linear-gradient(90deg, #D4AF37, transparent)' }} />
            </div>
          </div>

          {/* Images + Title row */}
          <div style={{ display: 'flex', gap: '4%', alignItems: 'center', marginBottom: '3%' }}>
            <div style={{ width: '32%', aspectRatio: '1/1', borderRadius: '50%', overflow: 'hidden', border: '1.5px solid rgba(212,175,55,0.4)', flexShrink: 0 }}>
              <img src={WOMAN_IMG} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} crossOrigin="anonymous" />
            </div>
            <div style={{ flex: 1 }}>
              <h1 style={{ color: 'white', fontSize: 'clamp(18px, 5.5vw, 30px)', fontWeight: 'bold', fontFamily: "'Cormorant Garamond', serif", margin: 0, letterSpacing: '2px', lineHeight: 1.1 }}>
                BREAKTHROUGH
              </h1>
              <p style={{ color: 'rgba(255,255,255,0.75)', fontSize: 'clamp(9px, 2.5vw, 13px)', fontStyle: 'italic', fontFamily: "'Cormorant Garamond', serif", margin: '2px 0 0' }}>
                A Faith-Based Guide to Healing
              </p>
            </div>
            <div style={{ width: '22%', aspectRatio: '4/3', borderRadius: '6px', overflow: 'hidden', border: '1.5px solid rgba(212,175,55,0.3)', flexShrink: 0 }}>
              <img src={BIBLE_IMG} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} crossOrigin="anonymous" />
            </div>
          </div>
        </div>

        {/* MIDDLE SECTION */}
        <div>
          {/* Empowering statement */}
          <div style={{ background: 'rgba(212,175,55,0.08)', borderLeft: '2px solid #D4AF37', padding: '8px 10px', borderRadius: '0 6px 6px 0', marginBottom: '3.5%' }}>
            <p style={{ color: 'white', fontSize: 'clamp(8.5px, 2.4vw, 12.5px)', fontStyle: 'italic', fontWeight: 'bold', lineHeight: 1.45, margin: 0, fontFamily: "'Nunito', sans-serif" }}>
              Are you ready to break free from limiting beliefs, let go of guilt, shame and blame due to trauma, particularly sexual abuse trauma? For all women wanting to start or continue their healing journey with powerful Christ-centred transformation.
            </p>
          </div>

          {/* Price */}
          <div style={{ textAlign: 'center', marginBottom: '3%' }}>
            <p style={{ color: 'white', fontSize: 'clamp(14px, 4vw, 20px)', fontWeight: 'bold', fontFamily: "'Nunito', sans-serif", margin: '0 0 1px' }}>
              E-Book from just £17
            </p>
            <p style={{ color: 'rgba(255,255,255,0.55)', fontSize: 'clamp(9px, 2.3vw, 12px)', fontStyle: 'italic', fontFamily: "'Nunito', sans-serif", margin: 0 }}>
              Coaching and Workshops also available
            </p>
          </div>

          {/* 3 Services */}
          <div style={{ display: 'flex', gap: '2%', marginBottom: '3%' }}>
            {[
              { t: '12-WEEK PROGRAMME', s: '1:1 Coaching' },
              { t: 'WORKSHOPS', s: 'Self-paced sessions' },
              { t: 'FREE CLARITY SESSION', s: '1-hour call' },
            ].map((item, i) => (
              <React.Fragment key={i}>
                {i > 0 && <div style={{ width: '1px', background: 'rgba(212,175,55,0.25)' }} />}
                <div style={{ flex: 1, textAlign: 'center' }}>
                  <p style={{ color: '#D4AF37', fontSize: 'clamp(5.5px, 1.6vw, 8.5px)', fontWeight: 'bold', letterSpacing: '0.8px', margin: '0 0 1px', fontFamily: "'Nunito', sans-serif" }}>{item.t}</p>
                  <p style={{ color: 'rgba(255,255,255,0.6)', fontSize: 'clamp(7px, 1.9vw, 10px)', fontStyle: 'italic', margin: 0, fontFamily: "'Nunito', sans-serif" }}>{item.s}</p>
                </div>
              </React.Fragment>
            ))}
          </div>

          {/* Scripture */}
          <div style={{ textAlign: 'center', marginBottom: '3%' }}>
            <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: 'clamp(7.5px, 2vw, 10.5px)', fontStyle: 'italic', fontFamily: "'Cormorant Garamond', serif", margin: 0 }}>
              "He heals the brokenhearted and binds up their wounds." — Psalm 147:3
            </p>
          </div>
        </div>

        {/* BOTTOM SECTION */}
        <div>
          {/* Website + QR Code row */}
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '4%', marginBottom: '2.5%' }}>
            <div style={{ textAlign: 'center' }}>
              <p style={{ color: '#D4AF37', fontSize: 'clamp(11px, 3vw, 16px)', fontWeight: 'bold', letterSpacing: '1.5px', fontFamily: "'Nunito', sans-serif", margin: '0 0 3px' }}>
                WWW.PURPOSERECLAIM.COM
              </p>
              <p style={{ color: 'rgba(255,255,255,0.35)', fontSize: 'clamp(5px, 1.4vw, 7px)', letterSpacing: '2px', textTransform: 'uppercase', fontFamily: "'Nunito', sans-serif", margin: '0 0 1px' }}>By</p>
              <p style={{ color: 'white', fontSize: 'clamp(11px, 3vw, 15px)', fontStyle: 'italic', fontFamily: "'Cormorant Garamond', serif", margin: 0 }}>
                Janelle McGowan-Charles
              </p>
            </div>
            <div style={{ background: 'white', padding: '4px', borderRadius: '6px', flexShrink: 0 }}>
              <QRCodeSVG 
                value="https://www.purposereclaim.com/links" 
                size={60}
                bgColor="white"
                fgColor="#5C0C33"
                level="M"
              />
            </div>
          </div>

          {/* CTA */}
          <div style={{ textAlign: 'center', marginBottom: '2.5%' }}>
            <div style={{ display: 'inline-block', border: '1px solid #D4AF37', borderRadius: '20px', padding: '4px 14px' }}>
              <span style={{ color: '#D4AF37', fontSize: 'clamp(6.5px, 1.8vw, 9.5px)', fontWeight: 'bold', letterSpacing: '1px', textTransform: 'uppercase', fontFamily: "'Nunito', sans-serif" }}>
                Scan to Start Your Healing Journey
              </span>
            </div>
          </div>

          {/* Social handles */}
          <div style={{ display: 'flex', justifyContent: 'center', gap: '8%' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <svg style={{ width: 'clamp(10px, 2.8vw, 15px)', height: 'clamp(10px, 2.8vw, 15px)' }} viewBox="0 0 24 24" fill="white"><path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zM12 0C8.741 0 8.333.014 7.053.072 2.695.272.273 2.69.073 7.052.014 8.333 0 8.741 0 12c0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98C8.333 23.986 8.741 24 12 24c3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98C15.668.014 15.259 0 12 0zm0 5.838a6.162 6.162 0 100 12.324 6.162 6.162 0 000-12.324zM12 16a4 4 0 110-8 4 4 0 010 8zm6.406-11.845a1.44 1.44 0 100 2.881 1.44 1.44 0 000-2.881z"/></svg>
              <span style={{ color: 'white', fontSize: 'clamp(8px, 2.3vw, 12px)', fontFamily: "'Nunito', sans-serif" }}>@jan_elle_9494</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
              <svg style={{ width: 'clamp(10px, 2.8vw, 15px)', height: 'clamp(10px, 2.8vw, 15px)' }} viewBox="0 0 24 24" fill="white"><path d="M19.59 6.69a4.83 4.83 0 01-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 01-2.88 2.5 2.89 2.89 0 01-2.89-2.89 2.89 2.89 0 012.89-2.89c.28 0 .54.04.79.1v-3.5a6.37 6.37 0 00-.79-.05A6.34 6.34 0 003.15 15.2a6.34 6.34 0 0010.86 4.48V13.2a8.16 8.16 0 005.58 2.2V12a4.85 4.85 0 01-3.77-1.54V6.69h3.77z"/></svg>
              <span style={{ color: 'white', fontSize: 'clamp(8px, 2.3vw, 12px)', fontFamily: "'Nunito', sans-serif" }}>@jan62249</span>
            </div>
          </div>
        </div>
      </div>

      {/* Download button */}
      <div style={{ textAlign: 'center', padding: '16px 12px', width: '100%', maxWidth: '420px' }}>
        <button 
          onClick={handleDownload}
          data-testid="download-flyer-btn"
          style={{
            width: '100%',
            padding: '14px',
            background: '#D4AF37',
            color: 'white',
            border: 'none',
            borderRadius: '30px',
            fontSize: '15px',
            fontWeight: 'bold',
            fontFamily: "'Nunito', sans-serif",
            letterSpacing: '1px',
            cursor: 'pointer',
          }}
        >
          SAVE FLYER TO PHOTOS
        </button>
        <p style={{ color: 'rgba(255,255,255,0.35)', fontSize: '11px', marginTop: '6px', fontFamily: "'Nunito', sans-serif" }}>
          Tap to download as an image
        </p>
      </div>
    </div>
  );
};
